import { Component, OnInit,ViewChild ,AfterViewInit} from '@angular/core';
import { HttpClient,HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { OrganismService } from '../organisms/organisms.service';
import { MasterService } from'../../masters/master.service';
import { OrganismModel } from '../organisms/organism.model';
import { Observable } from 'rxjs';
import { AddOrganismComponent } from '../organisms/add-organism/add-organism.component';
import { DepartmentModel } from '../../masters/add-department/department.model';
import { AddAddressComponent } from 'src/app/masters/add-address/add-address.component';
import { PartnerSearchComponent } from '../partner-search/partner-search.component';
import * as CommonConstants from '../../utils/common.constants';
import { LoaderService } from 'src/app/common/loader.service';
import { SharedService } from 'src/app/utils/shared.service';
@Component({
  selector: 'app-organisms',
  templateUrl: './organisms.component.html',
  styleUrls: ['./organisms.component.scss'],
  providers:[]
})
export class OrganismsComponent implements  OnInit {

  columnDefs:any[];
  rowData: OrganismModel[];
  organism : OrganismModel;
  organismSearch:OrganismModel=new OrganismModel();
  private defaultColDef;
  addOrganism;
  priv_addOrg:boolean=false;
  toggleColumn:boolean = true;
  countryList: any[];
  townList: any[];
  addressTypeList: any[];
  searchCollapse:boolean = true;

  //@ViewChild(AddOrganismComponent),{static: false}) organismComponent: AddOrganismComponent;
  @ViewChild(AddOrganismComponent,{static:true})   newOrganism : AddOrganismComponent;
  @ViewChild(PartnerSearchComponent,{static:true})   pSearch : PartnerSearchComponent;
  constructor(public router: Router,private organismService: OrganismService,private masterService:MasterService,private loaderService: LoaderService,private sharedService:SharedService) { 
   
  }
  searchOrganisms(){
    this.pSearch.pSearch["staRecCode"]=this.pSearch.pSearch["active"] ? 'A' : 'I';
    //this.organismService.searchOrganisms(this.organismSearch).subscribe(response => {
    this.loaderService.display(true);
    this.organismService.searchOrganisms(this.pSearch.pSearch).subscribe(response => {
      this.loaderService.display(false);
      this.rowData = response['result'];
    },
    error => {
      this.loaderService.display(false);
    })
    this.hideRightDiv();
  }
  onRowClicked(event : any){
    this.toggleColumn = false;
    this.addOrganism = true;
    this.searchCollapse = false;
    this.newOrganism.addOrganismTitle = false;
    this.newOrganism.editOrganismTitle = true;
    this.loadOrganism(event);   
  }
  hideRightDiv(){
    this.addOrganism = false;
    this.toggleColumn = true;
  }
  addNewOrganism(){
    this.router.navigate(['addOrganism']);   
  }
  
  loadOrganism(event: any){
    this.loaderService.display(true);
     this.organismService.getOrganismsById(event.data.orgsmId).subscribe(response => {
      this.loaderService.display(false);
      this.newOrganism.organismsDepartments.departmentList=[];
      this.newOrganism.organismsContact.employeeList=[];
      this.newOrganism.organismsAddress.addressList=[];
      this.newOrganism.organismsContact.partnerDepartment=[];
      if(response['code']=='S0000'){
        this.newOrganism.organism=new OrganismModel(); 
        this.patchValue(response['result']);
        this.newOrganism.organism.orgAddressList = this.newOrganism.organism.orgAddressList.map(item => ({
          ...item,
          addressType: item.typeId ? this.addressTypeList.find(obj => +obj.typeId === +item.typeId).description : null,
          townName: item.townId ? this.townList.find(town => town.townId === item.townId).townDescEn : null,
          countryName: item.cotryId ? this.countryList.find(country => country.cotryId === item.cotryId).cotryDescEn : null
        })); 
        this.newOrganism.organismsDepartments.departmentList=this.newOrganism.organism.orgDepartmentList;
        this.newOrganism.organismsContact.employeeList=this.newOrganism.organism.orgEmployeeList;
        //this.newOrganism.organismsContact.partnerDepartment=this.newOrganism.organism.orgDepartmentList;
        this.sharedService.setOrganismDepartment(this.newOrganism.organism.orgDepartmentList);
        this.newOrganism.organismsAddress.addressList=this.newOrganism.organism.orgAddressList;
        this.newOrganism.organismsContact.employeeList = this.newOrganism.organismsContact.employeeList.map(item => ({
          ...item,
          deptName: item.deptmId ? this.newOrganism.organism.orgDepartmentList.find(obj => +obj.deptmId === +item.deptmId).deptmNameEn : null,
        })); 
      }
      
    },
    error => {
      this.loaderService.display(false);
    }) 
    this.masterService.getPatientImageById(CommonConstants.PARTNER_ORGANISM_TYPE,event.data.orgsmId).subscribe(res => {
      if (res['code'] == 'S0000') {
        let response = res['result'];
        if (response['image'] != null) {
          this.newOrganism.url = 'data:image/png;base64,' + response['image'];
        } else {
          this.newOrganism.url = '';
        }
      } else {
        this.newOrganism.url = '';
      }

    })
    this.organism = new OrganismModel();
   
  }
  ngOnInit(){
    this.priv_addOrg=this.sharedService.hasPrivilege(CommonConstants.PRIV_ADD_ORGANISM);
    this.pSearch.partnerType=CommonConstants.PARTNER_ORGANISM_TYPE;
    this.pSearch.pSearch["active"]=true;
    this.searchOrganisms();
    this.loadMasterData();
  }
  ngAfterViewInit() {
    //alert('Values on ngAfterViewInit():');
    //console.log("add organism:", this.newOrganism);
  }

  loadMasterData(){
    this.masterService.getAddressTypes().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.addressTypeList = response['result'];
      }
    });
    this.masterService.getTown().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.townList = response['result'];
      }
    });

    this.masterService.getCountry().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.countryList = response['result'];
      }
    });
  }
  patchValue(result:any){
    this.newOrganism.organism.orgsmId= result.orgsmId;
    this.newOrganism.organism.compaVaNameEn= result.compaVaNameEn;	
    this.newOrganism.organism.compaVaEmail1= result.compaVaEmail1;
    this.newOrganism.organism.compaVaHomepage= result.compaVaHomepage; 
    this.newOrganism.organism.orgsmCode= result.orgsmCode;
    this.newOrganism.organism.compaVaWorkFax= result.compaVaWorkFax;
    this.newOrganism.organism.compaNuNumberEmployees= result.compaNuNumberEmployees; 
    this.newOrganism.organism.orgDepartmentList= result.orgDepartmentList;
    this.newOrganism.organism.orgAddressList= result.orgAddressList;
    this.newOrganism.organism.orgEmployeeList= result.orgEmployeeList;
    this.newOrganism.organism.staRecCode= result.staRecCode;
    this.newOrganism.organism.leforId= result.leforId;
    this.newOrganism.organism.cotryId= result.cotryId;
    this.newOrganism.organism.pacatId= result.pacatId;
    this.newOrganism.organism.pctypId= result.pctypId;
    this.newOrganism.organism.city= result.city;
    this.newOrganism.organism.curcyId= result.curcyId;
    this.newOrganism.organism.mobcode= result.mobcode;
    this.newOrganism.organism.workcode= result.workcode;
    this.newOrganism.organism.staRecCode === 'A' ?  this.newOrganism.organism.active=true :  this.newOrganism.organism.active=false;
    this.newOrganism.phoneNos.forEach(phone => {
      phone.phone=phone.getInternationPhoneFormat(result[phone.type]);
    })
  }
  clearForm(){
    this.organismSearch=new OrganismModel();
    this.router.navigate(['organisms']);   
    this.rowData =[];
    this.pSearch.pSearch={};
    this.hideRightDiv();
    
  }

  deleteRow(index){
    if(confirm("Are you sure")) {
    this.rowData = this.rowData.slice(0, index).concat( this.rowData.slice(index+1) );
    }
  }
}
